module.exports = __webpack_public_path__ + "img/mollusques.2bafcd77.svg";